import casinoServices from "../../services/CasinoService";
import memberService from "../../services/MemberService";
import { EVENT } from '../../events/listEvents';
import _ from 'lodash';
import i18next from 'i18next';
import APIS from "../../common/APIs";
import { CASINO_GAME_TYPE, PRODUCT_CODE, Product } from "../../common/Foundation";
const { AG, PT, IF, SG, agin, diamond, sapphire, DG } = CASINO_GAME_TYPE;
const { AGIN, PLAYTECH, IFORIUM, CR855, ION } = PRODUCT_CODE;
const { MAINTENANCE } = Product;


export default class CasinoAction {
  
  static translate(key){
    return i18next.t(key)
  }
  /**
  * Get content of Casino side bar
  */
  static async getCasinoSidebar() {
    return await casinoServices.getCasinoSideBarsAPI().then(response => {
      return response;
    }).catch(error => {
      console.log("Error getDataMyLastWinCasino" + error);
      throw error;
    });
  }

  /**
  * Init gameflex express library of iforium game
  */
  static initGameflexExpressLibray() {
    return casinoServices.initGameflexExpressLibrayAPI().then(response => {
      return response.data;
    }).catch(error => {
      console.log("Cannot load Gameflex Express Libray configuration: " + error);
      throw error;
    });
  }

  /**
   * Get Solid Game Launch Path
   */
  static getSolidGameLaunchPath(gameCode) {
    return casinoServices.getSolidGameLaunchPath(gameCode).then(response => {
      return response.data;
    }).catch(error => {
      console.log("Cannot load Gameflex Express Libray configuration: " + error);
      throw error;
    });
  }

  /**
  * Get Player currency for iforium game
  */
  static async getPlayerCurrencyCode() {
    return await casinoServices.getPlayerCurrencyCodeAPI().then(currencyCode => {
      return currencyCode;
    }).catch(error => {
      console.log("Cannot load PlayerCurrencyCode: " + error);
      throw error;
    });
  }

  /**
  * Get Player session for iforium game
  * @param {*} gameId
  */
  static async getPlayerSession(gameId) {
    return await casinoServices.getPlayerSessionAPI(gameId).then(response => {
      return response.data;
    }).catch(error => {
      console.log("Cannot load getPlayerSession: " + error);
      throw error;
    });
  }

  /**
  * Render promotion countdown info
  * @param {*} date
  */
  static getPromotionCountdown(date) {
    let today = new Date();
    let endDate = new Date(date);
    let diffMs = (endDate - today); // milliseconds between now & endDate
    let diffDays = Math.floor(diffMs / 86400000); // days
    let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    const countDownDate = {
      days: '00',
      hours: '00',
      minutes: '00',
    }
    if (diffDays > 0) {
      countDownDate.days = diffDays;
    }
    if (diffHrs > 0 && diffHrs < 24) {
      countDownDate.hours = diffHrs;
    }
    if (diffMins > 0 && diffMins < 60) {
      countDownDate.minutes = diffMins;
    }
    if (countDownDate.days > 0 && countDownDate.days < 10) {
      countDownDate.days = '0' +  countDownDate.days;
    }
    if (countDownDate.hours > 0 && countDownDate.hours < 10) {
      countDownDate.hours = '0' +  countDownDate.hours;
    }
    if (countDownDate.minutes > 0 && countDownDate.minutes < 10) {
      countDownDate.minutes = '0' +  countDownDate.minutes;
    }
    return countDownDate;
  }

  /**
   * Render Date info from current time
   * @param {*} date 
   */
  static renderDateInfoFromNow(date) {
    let today = new Date();
    let transDate = new Date(date);
    let diffMs = (today - transDate); // milliseconds between now & transDate
    let diffDays = Math.floor(diffMs / 86400000); // days
    let diffHrs = Math.floor((diffMs % 86400000) / 3600000) + Math.floor(diffDays * 24); // hours
    let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000) + Math.floor(diffHrs * 60); // minutes
    let text = '';
    //console.log("diffMins=" + diffMins + ", diffHrs=" + diffHrs + ", diffDays=" + diffDays + ", date=" + date);
    if (diffMins < 60) {
      text = text + Math.floor(diffMins) + (diffMins == 1 ? (" " + this.translate("casino:minute ago")) : (" " + this.translate("casino:minutes ago")));
    } else if (diffMins >= 60 && diffDays < 1) {
      text = text + Math.floor(diffHrs) + (diffHrs == 1 ? (" " + this.translate("casino:hour ago")) : (" " + this.translate("casino:hours ago")));
    } else if (diffDays < 7) {
      text = text + Math.floor(diffDays) + (diffDays == 1 ? (" " + this.translate("casino:day ago")) : (" " + this.translate("casino:days ago")));
    } else if (diffDays >= 7 && diffDays < 30) {
      let numWeek = Math.floor(diffDays / 7);
      text = text + numWeek + (numWeek == 1 ? (" " + this.translate("casino:week ago")) : (" " + this.translate("casino:weeks ago")));
    } else if (diffDays >= 30) {
      let numMonth = Math.floor(diffDays / 30);
      text = text + (numMonth > 1 ? this.translate("casino:More than a month ago") : (numMonth + (" " + this.translate("casino:month ago"))));
    }
    return text;
  }

  /**
   * Fire Event to casino game filter
   */
  static fireEventCasinoGameFilter() {
    window.fireEvent(EVENT.CASINO_GAME_FILTER);
  }

  /**
   * Fire Event to require login
   */
  static fireEventRequireLogin() {
    window.fireEvent(EVENT.REQUIRE_LOGIN);
  }

  /**
   * Fire Event to casino game filter
   */
  static fireEventOpenCasinoGame() {
    window.fireEvent(EVENT.CASINO_OPEN_GAME);
  }

  /**
   * Get category
   */
  static async getCategory() {
    return await casinoServices.getCategoryAPI().then(res => {
      return !_.isEmpty(res) ? res.data : null;
    }).catch(error => {
      console.log("Error getCategory");
      throw error;
    });
  }

  /**
   * Get category
   */
  static async getLiveCategory() {
    return await casinoServices.getLiveCategoryAPI().then(res => {
      return !_.isEmpty(res) ? res.data : null;
    }).catch(error => {
      console.log("Error getLiveCategoryAPI");
      throw error;
    });
  }

  /**
   * Update Casino Favourites
   */
  static async updateCasinoFavourites(casinoFavourites) {
    return await memberService.updateCasinoFavouritesAPI(casinoFavourites).then(res => {
      return !_.isEmpty(res) ? JSON.parse(res.data) : null;
    }).catch(error => {
      console.log("Error updateCasinoFavourites");
      throw error;
    });
  }

  static async updateCloseGameCasino(closeGame) {
    try{
      const res = await memberService.updateCloseGameCasinoAPI(closeGame);
      return !_.isEmpty(res) ? res.data : null;
    }catch(error){
      throw error;
    }
  }

  /**
   * Get Casino Favourites
   */
  static async getCasinoFavourites() {
    return await memberService.getCasinoFavouritesAPI().then(res => {
      return !_.isEmpty(res) ? res.data : null;
    }).catch(error => {
      console.log("Error getCasinoFavourites");
      throw error;
    });
  }

  /**
  * Call API to get Casino Backround
  * @param {*} casinoSliderFilter 
  */
 static async getCasinoBackground(casinoFilter) {
    let style = {}
    return await memberService.getCasinoBackgroundAPI(casinoFilter).then(res => {
      const data = _.get(res, 'data', []);
      if (data && data.length > 0) {
        const lang = sessionStorage.getItem('lng') || 'en';
        style = {
          'backgroundImage': `url(/${APIS.getMemberServicePath()}/${lang}${this.encodeMyURL(data[0])})`,
        }
      }
      return style;
    }).catch(error => {
      console.log("Error getCasinoBackground");
      return style;
    });
  }



  /**
   * Encode URL to specify name images
   * @param {*} url 
   */
  static encodeMyURL(url) {
    let arrayUrl = url.split("/"), urlAfterSplice = "";
    arrayUrl.splice(url.split("/").length - 1, 1);

    _.forEach(arrayUrl, (value, key) => {
      if (key > 0) {
        urlAfterSplice = urlAfterSplice + "/" + value;
      }
    });
    return urlAfterSplice + "?fileName=" + encodeURIComponent(url.split("/")[url.split("/").length - 1]).replaceAll("%", "%25");
  };

  /**
   * Call API to get casino sliders
   * @param {*} casinoSliderFilter 
   */
  static async getCasinoSliders(casinoSliderFilter) {
    return await casinoServices.getCasinoSliderAPI(casinoSliderFilter).then(res => {
      return !_.isEmpty(res) ? res.data : null;
    }).catch(error => {
      console.log("Error getCasinoSliders");
      throw error;
    });
  }

  /**
   * Call API to get Iforium providers
   */
  static async getIforiumProviders() {
    return await casinoServices.getIforiumProvidersAPI().then(res => {
      return !_.isEmpty(res) ? res.data : null;
    }).catch(error => {
      console.log("Error getIforiumProviders");
      throw error;
    });
  }

  /**
   * Call API to get Casino games
   */
  static getCasinoGames(casinoFilter) {
    return casinoServices.getCasinoGamesAPI(casinoFilter).then(res => {
      return !_.isEmpty(res) ? res.data : [];
    }).catch(error => {
      console.log("Error getCasinoGames");
      throw error;
    });
  }


  /**
   * Call API to get accounts balance
   */
  static async getAccountsBalance() {
    return await memberService.getAccountsBalanceAPI().then(res => {
      return !_.isEmpty(res) ? res.data : [];
    }).catch(error => {
      console.log("Error getAccountsBalance");
      throw error;
    });
  }

  /**
   * Call API to get active product wallet
   */
  static async getActiveProductWallet() {
    return await memberService.getActiveProductWalletAPI().then(res => {
      return !_.isEmpty(res) ? res.data : [];
    }).catch(error => {
      console.log("Error getActiveProductWallet");
      throw error;
    });
  }

  /**
   * Call API to transfer wallets
   */
  static async transferWallets(data) {
    return await memberService.transferWalletsAPI(data).then(res => {
      return !_.isEmpty(res) ? res.data : [];
    }).catch(error => {
      console.log("Error transferWallets");
      throw error;
    });
  }

  /**
   * Call API to ata transfer wallets
   */
  static async ataTransferWallets(data) {
    return await memberService.ataTransferWalletsAPI(data).then(res => {
      return !_.isEmpty(res) ? res.data : [];
    }).catch(error => {
      console.log("Error transferAtaWallets");
      throw error;
    });
  }

  /**
   * Call API to ata to Authorize
   */
  static async ataAuthorize(data) {
    return await memberService.ataAuthorizeAPI(data).then(res => {
      return !_.isEmpty(res) ? res.data : [];
    }).catch(error => {
      console.log("Error authorizeAtaWallets");
      throw error;
    });
  }

  /**
   * Call API to get AG game dispatcher Url
   */
  static async getAGGameDispatcherUrl(data) {
    return await memberService.getAGGameDispatcherUrlAPI(data).then(res => {
      return !_.isEmpty(res) ? res.data : {};
    }).catch(error => {
      console.log("Error getAGGameDispatcherUrl");
      throw error;
    });
  }

  static async getDGGameDispatcherUrl(params) {
      return await memberService.getDGGameDispatcherUrl(params);
  }

  /**
   * Call API to check Playtech player online
   */
  static async checkPlaytechPlayerOnline() {
    return await memberService.checkPlaytechPlayerOnlineAPI().then(result => {
      const response = _.get(result, 'data', {});
      let res = false;

      if (response.code === 2) {
        res = 2;
      } else if (response.code !== 2 && response.code !== 0) {
        console.log("Error when check status login : " + response.data);
      } else {
        res = response.data.value;
      }
      return res;
    }).catch(error => {
      console.log("Can not call server to check status login game of user.");
      throw error;
    });
  }

  /**
  * Call API to get Playtech player
  */
  static async getPlaytechPlayer() {
    return await memberService.getPlaytechPlayerAPI().then(res => {
      return !_.isEmpty(res) ? res.data : {};
    }).catch(error => {
      console.log("Error getPlaytechPlayer");
      throw error;
    });
  }

  /**
 * Get the image extension from the minetype
 * @param {*} type 
 */
  static getMineType(type) {
    let mineType = "jpeg";

    if (!_.isEmpty(type)) {
      mineType = type.substring(type.lastIndexOf('/') + 1, type.length);
    }

    return mineType;
  }

  /**
   * Get image path of games
   * @param {*} game 
   */
  static getImgPath(game) {
    const { gameType, imagePath, featured, iconImgPath, bannerImgPath } = game;

    let imgUrl = imagePath;
    switch (gameType) {
      case AG:
      case DG:
      case SG:
        imgUrl = featured ? bannerImgPath : iconImgPath;
        break;
      case IF:
        imgUrl = featured ? bannerImgPath : imagePath;
        break;
    }

     return {
       backgroundImage: `url("${imgUrl}")`
     };
  }

 /**
   * Get background image of games
   * @param {*} game 
   */
  static getBackgroundImgPath(game) {
    const { backgroundImgPath } = game;

    return backgroundImgPath ? {
      background: `url("${backgroundImgPath}"), url("/esthardsk/images/pa/backgrounds/game-window-top-bar-bg.jpg")`,
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat',
    } : {
      backgroundImage: `url(/esthardsk/images/pa/backgrounds/game-window-top-bar-bg.jpg)`,
        backgroundSize: `100% 100%`
      };
  }

/**
 * Get image path of a side bar game
 * @param {*} game 
 */
static getSideBarImgPath(game) {
    let imgUrl = game.imagePath;
     return {
      backgroundImage: `url("${imgUrl}"), url("/esthardsk/images/pa/no-image.svg")`
    }
}



  /**
   * Get product code by game type
   * @param {*} gameType 
   */
  static getProductCodeByGameType(gameType) {
    let productCode = '';

    switch (gameType) {
      case AG:
      case agin:
        productCode = AGIN;
        break;
      case PT:
        productCode = PLAYTECH;
        break;
      case IF:
        productCode = IFORIUM;
        break;
      case diamond:
        productCode = ION;
        break;
      case sapphire:
        productCode = CR855;
        break;
        case DG:
          productCode = DG;
          break;
      default:
        break;
    }

    return productCode;
  }

  /**
   * Check maintenance product
   * 
   * @param {*} gameType 
   * @param {*} productStatus 
   */
  static isMaintenanceProduct(gameType, productStatus) {
    let status = '';
    switch(gameType) {
      case agin:
        status = productStatus['AG'];
        break;
      case diamond:
        status = productStatus['ION'];
        break;
      case sapphire:
        status = productStatus['CR855'];
        break;
      case AG:
        status = productStatus['AGIN'];
        break;
      case PT:
        status = productStatus['PLAYTECH'];
        break;
      case IF:
        status = productStatus['IFORIUM'];
        break;
      case SG:
        status = productStatus['SG'];
        break;
      default:
        break;
    }

    return status === MAINTENANCE;
  }

  static getLiveGameClassName(game) {
    const { gameType, gameCode, isLiveCasino} = game;
    
    if (gameType == "ION") {
        const liveGameLst = _.filter(this.liveCasinoGames, liveGame => _.includes(liveGame.gameCode, gameCode))
        return _.get(liveGameLst, '[0].className', "");
    } else if (gameType == "AG" && isLiveCasino) {
        return game.gameCode || "agin_aghh"; 
    }
    return "";
  }

  static getLiveGameGameName(game) {
    const { gameType, gameCode} = game;
    if (gameType == "ION") {
        const liveGameLst = _.filter(this.liveCasinoGames, liveGame => _.includes(liveGame.gameCode, gameCode))
        return _.get(liveGameLst, '[0].gameName', "");
    }
    return "";
  }

  /**
   * Get Casino favorite provider
   * 
   * @param {*} casinoFavGames 
   * @param {*} categoryId 
   * @param {*} providers 
   */
  static getCasinoFavoriteProvider(casinoFavGames, categoryId, providers) {
    const favoriteProviders = _.filter(providers, (provider, index) => {
      return (provider.providerId == -2) || _.filter(casinoFavGames, (game, i) => {
        return game.providerId == provider.providerId && (categoryId === -1 || (categoryId !== -1 && game.categoryId == categoryId));
      }).length > 0;

    });
    return _.uniqBy(favoriteProviders, 'providerId');
  }

   /**
   * Get Casino favorite category
   * 
   * @param {*} casinoFavGames 
   * @param {*} categories 
   */
  static getCasinoFavoriteCategories(casinoFavGames, categories, isLiveCasino) {
    const favoriteCategories = []
    if (casinoFavGames) {
      const casinoFavFiltered = _.filter(casinoFavGames, fav => fav.liveCasino === isLiveCasino);
      const favoriteGamesCatesGroup = _.uniqBy(casinoFavFiltered, 'categoryId');

      _.forEach(favoriteGamesCatesGroup, (game) => {
        _.forEach(categories, (cate) => {
          const subCategory = cate['subCategory']
          const mainCategory = cate['mainCategory']
          let hasSub = false
          if (subCategory) {
            _.forEach(subCategory, (subCate) => {
              if (subCate && game.categoryId == subCate.id) {
                favoriteCategories.push(subCate)
                hasSub = true
                return;
              }
            })
          }
          if (!hasSub) {
            if (mainCategory && game.categoryId == mainCategory.id) {
              favoriteCategories.push(mainCategory)
              return;
            }
          }
        });
      });
    }
    return favoriteCategories;
  }

  /**
   * Get gameType code by product code
   * @param {*} productCode 
   */
  static getGameTypeByProductCode(productCode) {
    let gameType = '';

    switch (productCode) {
      case AGIN:
        gameType = AG;
        break;
      case IFORIUM:
        gameType = IF;
        break;
       case DG:
        gameType = DG;
        break; 
      default:
        break;
    }

    return gameType;
  }

  /**
 * Get game to launch API
 */
  static getCasinoGameByPath(casinoFilter) {
    return casinoServices.getCasinoGameByPathAPI(casinoFilter).then(res => {
      return !_.isEmpty(res) ? res.data : {};
    }).catch(error => {
      throw error;
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/app/components/CasinoComponent/CasinoAction.js